/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type FooterSubscribe_viewer$ref = any;
type LinkColumnItem_viewer$ref = any;
type SocialLinkRow_viewer$ref = any;
export type LinkColumn_viewer$ref = any;
export type LinkColumn_viewer = {
    readonly " $fragmentRefs": LinkColumnItem_viewer$ref & SocialLinkRow_viewer$ref & FooterSubscribe_viewer$ref;
    readonly " $refType": LinkColumn_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "LinkColumn_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "LinkColumnItem_viewer",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SocialLinkRow_viewer",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "FooterSubscribe_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = '949599fa3d1051d3b70598b188ace130';
export default node;
